import * as React from 'react';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import bindAllOfThis from 'src/utils/BindThisHelper'; // 'this' binder
import { Input, Modal, Upload, Button, Icon } from 'antd';
import { UploadFile, UploadProps } from "antd/lib/upload/interface";
import StudentStatementDTO from "src/models/statement/StudentStatementDTO";
import UserCompletionDTO from "src/models/statement/UserCompletionDTO";

interface EditStatementNotesModalProps extends LocalizeContextProps {
    statement: StudentStatementDTO;
    visible: boolean;
    onOk: (values: StudentStatementModalReturn) => void;
    onCancel: () => void;
}

interface EditStatementNotesModalState {
    userCompletion: UserCompletionDTO;
    fileList: UploadFile[];
    removedFileIds: number[];
    submitting: boolean;
}

export interface StudentStatementModalReturn extends StudentStatementDTO {
    fileList: UploadFile[];
    removedFileIds: number[];
}

class EditStatementNotesModal extends React.Component<EditStatementNotesModalProps, EditStatementNotesModalState> {
    constructor(props: EditStatementNotesModalProps) {
        super(props);
        bindAllOfThis(this, EditStatementNotesModal.prototype);

        this.state = {
            userCompletion: {} as UserCompletionDTO,
            fileList: [],
            removedFileIds: [],
            submitting: false
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
    }

    componentWillReceiveProps(newProps: EditStatementNotesModalProps) {
        if (this.props.activeLanguage !== newProps.activeLanguage || this.props.statement.statementId !== newProps.statement.statementId) {
            this.deriveStateFromProps(newProps);
        }
    }

    deriveStateFromProps(newProps: EditStatementNotesModalProps) {
        this.setState({
            userCompletion: newProps.statement.userCompletion || {} as UserCompletionDTO,
            fileList: newProps.statement.userCompletion != null
                ? newProps.statement.userCompletion.statementFiles.map<UploadFile>(x => {
                    let newFile: UploadFile = undefined;
                    if (x != null) {
                        newFile = {
                            uid: x.id.toString(),
                            name: x.fileName,
                            status: 'done',
                            thumbUrl: x.azureFileUrl,
                        } as UploadFile;
                    }
                    return newFile;
                })
                : [],
        });
    }

    private onOk(e: React.MouseEvent<any>) {
        this.setState({ submitting: true });
        let output: StudentStatementModalReturn = {
            ...this.props.statement,
            userCompletion: this.state.userCompletion,
            fileList: this.state.fileList,
            removedFileIds: this.state.removedFileIds
        };
        this.props.onOk(output);
    }

    private onCancel() {
        this.setState({
            userCompletion: null,
        });
        this.props.onCancel();
    }

    private handleStudentNoteChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
        let { userCompletion } = this.state;
        userCompletion.statementNotes = e.target.value;

        this.setState({
            userCompletion: userCompletion
        });
    }

    private handleFileChange = (info) => {
        let newFileList = info.fileList.filter(file => file.status == null || file.status !== "removed");
        let { removedFileIds } = this.state;
        if (info.file.status != null && info.file.status === "removed" && info.file.originFileObj == null) {
            removedFileIds.push(info.file.uid as number);
        }

        this.setState({ fileList: newFileList, removedFileIds: removedFileIds });
    }

    render() {
        if (this.props.statement == null || this.state.userCompletion == null) {
            return null;
        }

        const uploadProps: UploadProps = {
            action: "",
            onChange: this.handleFileChange,
            beforeUpload: (file) => {
                // Stop the actual file upload process, we will do that later
                return false;
            },
            fileList: this.state.fileList,
            listType: "picture",
            multiple: true
        };

        return <Modal
            maskClosable={false}
            visible={this.props.visible}
            onOk={this.onOk}
            onCancel={this.onCancel}
            footer={[
                <Button key="back" onClick={this.onCancel}><Translate id="admin.common.cancelButton" /></Button>,
                <Button key="submit" onClick={this.onOk} loading={this.state.submitting}><Translate id="admin.common.saveButton" /></Button>
            ]}
        >
            <div>
                <h3>{this.props.statement.statementText}</h3>
                <label>{this.props.translate("public.studentStatements.notesHeader")}:</label>

                <Input.TextArea
                    key={"studentNotes"}
                    rows={3}
                    autoComplete="off"
                    value={this.state.userCompletion.statementNotes}
                    onChange={this.handleStudentNoteChange}>
                </Input.TextArea>

                <Upload {...uploadProps} >
                    <Button>
                        <Icon type="upload" /> Select File
                    </Button>
                </Upload>
            </div>
        </Modal>;
    }
}

export default withLocalize(EditStatementNotesModal);



// WEBPACK FOOTER //
// ./src/components/student/EditStatementNotesModal.tsx